import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AcademicFeePriceDto } from '../models/academicfeepricedto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})

export class AcademicTaxesPriceService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    getByAcademicFeeId(pageRequest: PaginationFeaturesDto, idOwnAcademicFee: number): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/own-academic-fee/price/getAll?${params}&idOwnAcademicFee=${idOwnAcademicFee}`).pipe(
            map(response => { return response; }));
    }

    insertPrice(academicFeePriceDto: AcademicFeePriceDto, currentLanguage: string): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-academic-fee/price/insert`;
        const headers = { 'Accept-Language': currentLanguage }; // Obtiene el idioma actual
        return this.http.post<any>(url, academicFeePriceDto, { headers }).pipe(
            map(response => {
                return response;
            })
        );
    }

    updatePrice(academicFeePriceDto: AcademicFeePriceDto, currentLanguage: string): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-academic-fee/price/update`;
        const headers = { 'Accept-Language': currentLanguage }; // Obtiene el idioma actual
        return this.http.put<any>(url, academicFeePriceDto, { headers }).pipe(
            map(response => {
                return response;
            })
        );
    }

    clonePrice(idOwnAcademicFeePrice: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-academic-fee/price/duplicate/${idOwnAcademicFeePrice}`;
        return this.http.post<any>(url, AcademicFeePriceDto).pipe(map(response => { return response; }));
    }
}